import React from 'react'
import { Link } from 'react-router-dom'
import '../css/style.css'

const Ending = () => {
  return (
    <>
    <footer >
    <h1>Our Ride</h1>
    <div className='footer'>

    <ul className='lists'>
            <li className=''><Link to='*' className='navigate'>Rides</Link></li>
            <li><Link to='*' className='navigate'>Food Delivery</Link></li>
            <li><Link to='*' className='navigate'>Grocery Delivery</Link></li>
            <li><Link to='*' className='navigate'>Scooters</Link></li>
            <li><Link to='*' className='navigate'>Car-Sharing</Link></li>
            <li><Link to='*' className='navigate'>Business</Link></li>
            <li><Link to='*' className='navigate'>Airport</Link></li>
            <li><Link to='*' className='navigate'>Cities</Link></li>
        </ul>
        <ul className='lists'>
            <li><Link to='*' className='navigate'>Rides</Link></li>
            <li><Link to='*' className='navigate'>Food Delivery</Link></li>
            <li><Link to='*' className='navigate'>Grocery Delivery</Link></li>
            <li><Link to='*' className='navigate'>Scooters</Link></li>
            <li><Link to='*' className='navigate'>Car-Sharing</Link></li>
            <li><Link to='*' className='navigate'>Business</Link></li>
            <li><Link to='*' className='navigate'>Airport</Link></li>
            <li><Link to='*' className='navigate'>Cities</Link></li>
        </ul>
        <ul className='lists'>
            <li><Link to='*' className='navigate'>Rides</Link></li>
            <li><Link to='*' className='navigate'>Food Delivery</Link></li>
            <li><Link to='*' className='navigate'>Grocery Delivery</Link></li>
            <li><Link to='*' className='navigate'>Scooters</Link></li>
            <li><Link to='*' className='navigate'>Car-Sharing</Link></li>
            <li><Link to='*' className='navigate'>Business</Link></li>
            <li><Link to='*' className='navigate'>Airport</Link></li>
            <li><Link to='*' className='navigate'>Cities</Link></li>
        </ul>
        <ul className='lists'>
            <li><Link to='*' className='navigate'>Rides</Link></li>
            <li><Link to='*' className='navigate'>Food Delivery</Link></li>
            <li><Link to='*' className='navigate'>Grocery Delivery</Link></li>
            <li><Link to='*' className='navigate'>Scooters</Link></li>
            <li><Link to='*' className='navigate'>Car-Sharing</Link></li>
            <li><Link to='*' className='navigate'>Business</Link></li>
            <li><Link to='*' className='navigate'>Airport</Link></li>
            <li><Link to='*' className='navigate'>Cities</Link></li>
        </ul>
    </div>
       
    </footer>
    </>
  )
}

export default Ending